import Icon from '@ant-design/icons';
import { Common } from '@stockbit/ui';
import { useState } from 'react';
import { Col, Form, Row } from 'antd';
import ChatSvg from 'global/Icons/ChatSvg';
import WhatsAppSvg from 'global/Icons/WhatsAppSvg';
import OtpMethodList from 'global/OtpMethodList';
import { OtpChannel } from 'typings/auth';
import { VerifyPhoneErrorType } from 'features/register/types';
import { AxiosError } from 'axios';
import { formatPhoneNumber } from 'utils/textFormatter';
import { OtpMethodSubmit } from './styled';
import changePhoneStore from './store';
import { ExodusResponse } from '../../../../@types/api-response';

const { Text } = Common;

interface SelectOtpMethodProps {
  title?: string;
  description?: string[];
  buttonText?: string;
  onNext?(): void;
  onError?(errorType: VerifyPhoneErrorType): void;
}

const SelectOtpMethod = ({
  title = 'Pilih Metode Pengiriman Kode Verifikasi',
  description = ['Pastikan nomor', 'benar sebelum mengirimkan OTP'],
  buttonText = 'Kirim',
  onNext = () => {},
  onError = () => {},
}: SelectOtpMethodProps) => {
  const [selectedMethod, setSelectedMethod] = useState<OtpChannel>(
    OtpChannel.WhatsApp,
  );
  const [phoneData, isLoading, updatePhone] = changePhoneStore((s) => [
    s.phone,
    s.isLoading,
    s.updatePhone,
  ]);

  const handleOtpSelect = (value: OtpChannel) => {
    setSelectedMethod(value);
  };

  const handleFormFinish = async () => {
    try {
      const res = await updatePhone({
        ...phoneData,
        channel: selectedMethod,
      });

      if (res?.data !== undefined) {
        onNext();
      }
    } catch (e) {
      const { error_type: errorType } =
        (e as AxiosError<ExodusResponse>)?.response?.data || {};
      if (errorType) onError(errorType as VerifyPhoneErrorType);
    }
  };

  return (
    <Form onFinish={handleFormFinish}>
      <Row gutter={[0, 16]}>
        <Col span={24}>
          <Text size="16px" height="22px" color="#333333" weight="bold">
            {title}
          </Text>
        </Col>
        <Col span={24}>
          <Text size="14px" height="19px" color="#858585">
            {description[0]}{' '}
            <b>+{formatPhoneNumber(`${phoneData?.code}${phoneData?.phone}`)}</b>{' '}
            {description[1]}
          </Text>
        </Col>

        <Col span={24}>
          <OtpMethodList
            defaultMethod={selectedMethod}
            data={[
              {
                value: OtpChannel.WhatsApp,
                title: 'Kirim melalui WhatsApp',
                description: 'Bebas biaya',
                icon: (
                  <Icon component={WhatsAppSvg} style={{ color: '#00AB6B' }} />
                ),
              },
              {
                value: OtpChannel.Sms,
                title: 'Kirim melalui SMS',
                description: 'Berlaku tarif pengiriman SMS',
                icon: <Icon component={ChatSvg} style={{ color: '#00AB6B' }} />,
              },
            ]}
            onSelect={handleOtpSelect}
          />
        </Col>

        <Col span={24}>
          <OtpMethodSubmit
            type="primary"
            disabled={!selectedMethod}
            htmlType="submit"
            loading={isLoading}
            data-cy="pin-form-otp-method-submit"
          >
            {buttonText}
          </OtpMethodSubmit>
        </Col>
      </Row>
    </Form>
  );
};

export default SelectOtpMethod;
